window.captureCalendarSnapshot = function (direction, uniqueId) {
    const outClass = direction === 'nav-next' ? 'nav-out-left' : 'nav-out-right';
    const root = uniqueId ? (document.querySelector('.' + uniqueId + '-popup') || document) : document;

    // Animate the whole calendar view (all months) as a single unit rather than
    // each month table separately.
    root.querySelectorAll('.calendar-body .k-calendar-view').forEach(view => {
        const parent = view.parentElement;
        const parentRect = parent.getBoundingClientRect();
        const viewRect = view.getBoundingClientRect();

        if (getComputedStyle(parent).position === 'static') parent.style.position = 'relative';
        parent.style.overflow = 'hidden';

        parent.querySelectorAll('.k-calendar-view-snapshot').forEach(el => el.remove());

        const clone = view.cloneNode(true);
        clone.classList.add('k-calendar-view-snapshot');
        clone.classList.remove('nav-next', 'nav-prev', 'nav-out-left', 'nav-out-right');
        clone.style.cssText = [
            'position:absolute',
            `top:${viewRect.top - parentRect.top}px`,
            `left:${viewRect.left - parentRect.left}px`,
            `width:${view.offsetWidth}px`,
            'pointer-events:none',
            'z-index:2',
            'margin:0'
        ].join(';');

        parent.appendChild(clone);
        clone.classList.add(outClass);
        clone.addEventListener('animationend', () => clone.remove(), { once: true });
    });
};

window.triggerCalendarAnimation = function (direction, uniqueId) {
    const root = uniqueId ? (document.querySelector('.' + uniqueId + '-popup') || document) : document;

    // Slide the entire calendar view in as one unit so both months move together.
    root.querySelectorAll('.calendar-body .k-calendar-view').forEach(view => {
        const parent = view.parentElement;
        if (getComputedStyle(parent).position === 'static') parent.style.position = 'relative';
        parent.style.overflow = 'hidden';

        view.classList.remove('nav-next', 'nav-prev');
        void view.offsetWidth;
        view.classList.add(direction);
    });

    root.querySelectorAll('.calendar-body .k-calendar-header .HeadingsH4').forEach(h => {
        h.classList.remove('header-nav-in');
        void h.offsetWidth;
        h.classList.add('header-nav-in');
    });
};

window.registerDrpInstance = function (dotNetRef) {
    // Find the input elements rendered by TelerikDatePicker
    const bindSide = (prop, selector, method) => {
        if (!window[prop]) {
            window[prop] = document.querySelector(selector);
        }
        if (window[prop]) {
            window[prop].addEventListener("focus", () => dotNetRef.invokeMethodAsync(method));
        }
    };

    bindSide("drpStartInput", ".drp-start input", "NotifyStartClicked");
    bindSide("drpEndInput", ".drp-end input", "NotifyEndClicked");
};

// Per-instance light-dismiss for the date range calendar popup.
// A click closes the calendar unless it lands inside the picker's anchor element
// or inside its own popup (rendered at the document body by Telerik). Escape also closes.
// Keyed by instanceId so multiple pickers on a page close independently.
window.drpOutsideClose = (function () {
    const listeners = new Map();
    let mouseDownPos = null;
    const DRAG_THRESHOLD = 5;

    document.addEventListener('mousedown', (e) => {
        mouseDownPos = { x: e.clientX, y: e.clientY };
    });

    return {
        register: function (dotNetRef, anchorId, popupClass, instanceId) {
            this.dispose(instanceId);

            const close = () => dotNetRef.invokeMethodAsync('OnClickOutside').catch(() => { });
            const closeFromEscape = () => dotNetRef.invokeMethodAsync('OnEscapeKey').catch(() => { });

            const onClick = (e) => {
                const down = mouseDownPos;
                mouseDownPos = null;

                if (down) {
                    const dx = e.clientX - down.x;
                    const dy = e.clientY - down.y;

                    if ((dx * dx + dy * dy) > (DRAG_THRESHOLD * DRAG_THRESHOLD)) {
                        return;
                    }
                }

                const insideAnchor = anchorId && e.target.closest('#' + anchorId);
                const insidePopup = popupClass && e.target.closest('.' + popupClass);

                if (insideAnchor || insidePopup) {
                    return;
                }

                close();
            };

            const onKeyDown = (e) => {
                if (e.key === 'Escape') {
                    closeFromEscape();
                } else if ((e.key === ' ' || e.key === 'Spacebar' || e.code === 'Space') && isFocusInsideDrpPopup(instanceId)) {
                    // Telerik selects the focused day on Enter but not Space; mirror it so Space
                    // also selects the day the arrow keys are currently on.
                    const active = document.activeElement;
                    const activeIsGrid = !!(active && active.matches && active.matches('table.k-calendar-table'));
                    if (!activeIsGrid) {
                        return;
                    }

                    const popup = getDrpPopup(instanceId);
                    const focusedDay = popup && popup.querySelector('.k-calendar-td.k-focus .k-link');
                    e.preventDefault();
                    if (focusedDay) {
                        focusedDay.click();
                    }
                }
            };

            document.addEventListener('click', onClick);
            document.addEventListener('keydown', onKeyDown);
            listeners.set(instanceId, { onClick, onKeyDown });
        },

        dispose: function (instanceId) {
            const entry = listeners.get(instanceId);
            if (entry) {
                document.removeEventListener('click', entry.onClick);
                document.removeEventListener('keydown', entry.onKeyDown);
                listeners.delete(instanceId);
            }
        }
    };
})();

window.registerDrpOutsideClose = function (dotNetRef, anchorId, popupClass, instanceId) {
    window.drpOutsideClose.register(dotNetRef, anchorId, popupClass, instanceId);
};

window.disposeDrpOutsideClose = function (instanceId) {
    window.drpOutsideClose.dispose(instanceId);
};

function getDrpPopup(uniqueId) {
    return document.getElementsByClassName(uniqueId + "-popup")[0] || null;
}

function isDrpCalendarOpen(uniqueId) {
    const popup = getDrpPopup(uniqueId);
    if (!popup) return false;
    const calendar = popup.querySelector('.k-calendar');
    // offsetParent is null when the popup (or an ancestor) is display:none / hidden.
    return !!(calendar && calendar.offsetParent !== null);
}

function isFocusInsideDrpPopup(uniqueId) {
    const popup = getDrpPopup(uniqueId);
    return !!(popup && document.activeElement && popup.contains(document.activeElement));
}

// Telerik makes the month-view <table class="k-calendar-table" role="grid" tabindex="0"> the
// focusable element (the day cells are plain, non-focusable spans), so that's what gets focused.
function getDrpCalendarTable(popup) {
    return popup.querySelector('table.k-calendar-table[tabindex="0"]') ||
        popup.querySelector('table.k-calendar-table');
}

// Move focus onto the calendar grid so the arrow keys navigate days.
function focusDrpDay(uniqueId) {
    const popup = getDrpPopup(uniqueId);
    if (!popup) return false;
    const target = getDrpCalendarTable(popup) || popup.querySelector('.k-calendar-view');
    if (target) {
        target.focus();
        return true;
    }
    return false;
}

// Called right after the popup opens. The popup renders/shows over one or more Blazor
// Server round-trips, and an early render can blur a too-eager focus, so we keep
// re-asserting focus until it has actually landed inside the calendar and stuck.
window.focusDateRangePickerCalendar = function (uniqueId) {
    let attempts = 0;
    let stableTicks = 0;
    const tick = function () {
        attempts++;
        const popup = getDrpPopup(uniqueId);
        const focusInside = popup && document.activeElement && popup.contains(document.activeElement);

        if (focusInside) {
            // Focus is in the calendar; confirm it stays for a couple of ticks before stopping.
            if (++stableTicks >= 2) return;
        } else if (popup) {
            const target = getDrpCalendarTable(popup);
            // Only focus once the calendar is actually visible (offsetParent is null while hidden).
            if (target && target.offsetParent !== null) {
                target.focus();
            }
            stableTicks = 0;
        }

        if (attempts < 30) {
            setTimeout(tick, 40);
        }
    };
    setTimeout(tick, 20);
}

window.focusDateRangePickerIcon = function (containerId, isStart) {
    const container = document.getElementById(containerId);
    if (!container) return;
    const selector = isStart ? '.fromDateContainer .icon-div' : '.toDateContainer .icon-div';
    const icon = container.querySelector(selector);
    if (icon) icon.focus();
}

function getDrpSideInput(container, isStart) {
    return container.querySelector(isStart ? '.drp-start input' : '.drp-end input');
}

// A field counts as "filled in" once its input has real typed text — used to decide whether
// Tab from that side's icon should still jump into the day grid (still exploring/picking a date)
// or let Tab proceed normally onto the next field (already typed a value, done with this one).
function isDrpFieldFilled(container, isStart) {
    const input = getDrpSideInput(container, isStart);
    return !!(input && input.value && input.value.trim().length > 0);
}

// Calendar icons act as buttons: Enter/Space toggles the calendar; Tab alone never opens it (the
// input is always in the DOM — see the CSS that hides it until it's floating or focused — so Tab
// reaches it natively without any JS help). While the calendar is open AND the corresponding
// field is still empty, Tab moves focus off the icon and onto the day grid so arrow keys can
// pick a date. Once that field has a typed value, Tab is left alone so it moves on to the next
// field instead of detouring through the popup.
window.setupDrpKeyboardEvents = function (dotNetRef, containerId, uniqueId) {
    const container = document.getElementById(containerId);
    if (!container) return;

    const bindIcon = (sideSelector, isStart) => {
        const iconButton = container.querySelector(sideSelector + ' .icon-div');
        if (!iconButton || iconButton.dataset.kbBound) return;
        iconButton.dataset.kbBound = "true";
        iconButton.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                e.preventDefault();
                // Stop the document-level Escape/outside-click handler from also acting on this key.
                e.stopPropagation();
                dotNetRef.invokeMethodAsync('ToggleCalendarFromKeyboard', isStart);
            } else if (e.key === 'Tab' && !e.shiftKey && isDrpCalendarOpen(uniqueId) && !isDrpFieldFilled(container, isStart)) {
                if (focusDrpDay(uniqueId)) {
                    e.preventDefault();
                }
            }
        });
    };

    bindIcon('.fromDateContainer', true);
    bindIcon('.toDateContainer', false);
}

// True when the input's entire value is already highlighted, so a further select() would be a
// no-op. select()/focus() causes infinite loop where telerik focuses the input, then we focus it again, then telerik focuses it again, etc.
// Used to stop select()/focus() feedback loops with Telerik's own caret handling.
function isDrpFullySelected(input) {
    return input.selectionStart === 0 && input.selectionEnd === input.value.length;
}

function trySelect(input) {
    // Telerik may re-trigger this focus handler when managing the caret,
    // causing an infinite focus/select loop. Stop once everything is selected.
    if (isDrpFullySelected(input)) return;

    try {
        input.select();
    } catch {
        // Ignore inputs that don't support text selection.
    }
}

// Kendo's date input already selects the whole "MM/DD/YYYY" value when focus arrives via Tab,
// but a mouse click just drops a caret at the click position (the browser resets the selection
// on mouseup). Re-select everything after that reset so click matches Tab's behavior.
window.setupDrpSelectAllOnFocus = function (containerId) {
    const container = document.getElementById(containerId);
    if (!container) return;

    const bindInput = (isStart) => {
        const input = getDrpSideInput(container, isStart);
        if (!input || input.dataset.selectAllBound) return;
        input.dataset.selectAllBound = "true";

        const selectAll = () => requestAnimationFrame(() => trySelect(input));

        input.addEventListener('focus', selectAll);
        input.addEventListener('click', selectAll);
    };

    bindInput(true);
    bindInput(false);
}

// When a field starts out empty, its input is in the DOM but CSS-hidden (opacity 0) until the
// container click reveals it by opening the calendar, so there's nothing visibly focusable yet at
// click time. Once the reveal has had a moment to settle, highlight the newly-visible input's
// mask placeholder — a deliberately small delay so it reads as "the field just appeared" rather
// than instant.
window.selectDrpInputDelayed = function (containerId, isStart) {
    setTimeout(() => {
        const container = document.getElementById(containerId);
        if (!container) return;
        const input = getDrpSideInput(container, isStart);
        if (!input) return;
        try {
            input.focus();
            input.select();
        } catch {
            // Ignore inputs that don't support text selection.
        }
    }, 180);
}

function initializeDatePickerFocus() {
    const container = document.querySelector('.container-for-dateRangeLabelContainer');
    if (!container) return;

    const fromDateContainer = container.querySelector('.fromDateContainer');
    const toDateContainer = container.querySelector('.toDateContainer');

    if (!fromDateContainer || !toDateContainer) return;

    const activate = (active, inactive) => {
        active.classList.add('isDateSelected');
        inactive.classList.remove('isDateSelected');
    };

    container.addEventListener('focusin', (e) => {
        const target = e.target;
        if (!target.classList.contains('k-input-inner')) return;

        if (target.closest('.fromDateContainer')) {
            activate(fromDateContainer, toDateContainer);
        } else if (target.closest('.toDateContainer')) {
            activate(toDateContainer, fromDateContainer);
        }
    });

    container.addEventListener('focusout', (e) => {
        setTimeout(() => {
            if (!container.contains(document.activeElement)) {
                fromDateContainer.classList.remove('isDateSelected');
                toDateContainer.classList.remove('isDateSelected');
            }
        }, 10);
    });
}

globalThis.initializeDatePickerFocus = initializeDatePickerFocus;